// TODO: migrate to ./store.js
export default {
	saveExistingOutcome_errorMessage: "There was an error saving the outcome: {message}",
	deleteExistingOutcome_errorMessage: "There was an error deleting the outcome: {message}",
	saveNewOutcome_errorMessage: "There was an error saving the outcome: {message}",
};



// WEBPACK FOOTER //
// ./src/lang/en/meetingAgendaStore.js